import {postVideoSchema, PostVideoType} from '../../../../../../../../../service/posts/posts-types';

export function isPostVideoUploadType(data: unknown): data is PostVideoType {
    return postVideoSchema.safeParse(data).success;
}
